<div
  class="flex h-full w-full items-center justify-center gap-2 rounded-lg border bg-white p-3 shadow-sm transition-all duration-200 xl:gap-3">
  <div
    class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-slate-200 xl:h-12 xl:w-12">
    <mat-icon
      class="material-symbols-outlined qaroni-mat-icon-18 text-primary-30"
      [fontIcon]="icon()" />
  </div>
  <div class="flex flex-col justify-center">
    <span class="text-center text-xs font-medium text-gray-600">
      {{ label() }}
    </span>
    <span class="text-center text-base font-medium md:text-lg xl:text-lg">{{
      time()
    }}</span>
  </div>
</div>
